import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScheduleDadjService {

  constructor(private http: HttpClient) {}

  loadJsonObject(baseUrl: string, params: Record<string, any>): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    return this.http.get<any>(`${url}?${urlEncoded.toString()}`, { withCredentials: true });
  }

  saveScheduleD(baseUrl: string, formData: any[]): Observable<any> {
    const url = `${baseUrl}/saveFedForm?process_name=ScheduleDdata`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const urlEncoded = new URLSearchParams();
    urlEncoded.set('jsonObj', JSON.stringify(formData));

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      map(response => response)
    );
  }
}
